import AbstractGuestlistDetailsPageController from './abstract-details-controller';
import MultipleElementsSelectModalController from '../../../../seatplans/controllers/modals/seatplan/multiple-elements-select-modal';
import doBookingModalTemplate from '../../../views/seats/do-booking-modal.tpl.html';
import bookingInformationModalTemplate from '../../../views/seats/booking-information-modal.tpl.html';
import multipleElementsSelectModalTemplate from '../../../../seatplans/views/modals/seatplan/multiple-elements-select-modal.tpl.html';

export default class GuestlistSeatplanPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.queue = this.injector.get('$q');
        this.navService = this.injector.get('NavService');
        this.filter = this.injector.get('$filter');

        this.modal = this.injector.get('$uibModal');
        this.usersFastPipe = this.injector.get('Users');
        this.acl = this.injector.get('Acl');

        this.loading = true;
        this.error = true;

        this.guestlist = null;
        this.guestlistId = this.stateParams.gid;
        this.seatplan = null;
        this.currentGroup = this.stateParams.preSelectGroup;

        this.blockedElements = [];
        this.guestlists = [];

        this.availableShifts = {};
        this.availableDates = {};
        this.currentSelectedDate = '';
        this.currentSelectedShift = '';
        this.guestlistMapping = [];
        this.guestlistSelectionError = false;

        this.bookingInformation = {};
        this.resetSelectedIndex = 1;
        this.selected = {
            ids: [],
            objects: []
        };

        this._initPusherWatcher();
        this._loadGuestlists();
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this.loading = true;

        this.guestlistId = this.guestlist.id;

        let oldGroupId = this.currentGroup;

        _.forEach(this.guestlist.blockedSeatplanElements.data, (val) => {
            this.blockedElements.push(val.id);
        });

        this.currentSelectedDate = this.filter('date')(this.guestlist.date, 'yyyy-MM-dd');
        this.currentSelectedShift = this.guestlist.shift.id + '';

        this.queue
            .all([
                this.api
                    .get(`seatplans/${this.guestlist.seatplan_id}?include=groups,areas`)
                    .then(({data}) => {
                        this.seatplan = data.data;

                        if (!oldGroupId) {
                            this.currentGroup = this.seatplan.groups.data[0].id;
                        } else {
                            this.currentGroup = oldGroupId;
                        }
                    })
                    .catch(e => this.alert.handle(e)),
                this._refreshRsvpInformation()
            ])
            .then(() => {
                if (this.stateParams.rsvpId) {
                    this.api
                        .get(`rsvps/${this.stateParams.rsvpId}`)
                        .then(({data}) => {
                            const rsvpToOpen = data.data;

                            _.each(this.seatplan.groups.data, (group) => {
                                if (group.id === rsvpToOpen.main_seatplan_group_id) {
                                    this.activateGroup(group);
                                }
                            });

                            this.openRsvpInformationModal(rsvpToOpen);
                            this._updateCustomActions();
                            this._updateToolbox();
                            this.loading = false;
                        })
                } else {
                    this._updateCustomActions();
                    this._updateToolbox();
                    this.loading = false;
                }
            });
    }

    _loadGuestlists() {
        new Promise((resolve) => {
            if (this.stateParams.guestlists && this.stateParams.guestlists.length > 0) {
                resolve(this.stateParams.guestlists);
                return;
            }

            this.api
                .post('fp/guestlists', {
                    fields: [
                        'id',
                        'name',
                        'date',
                        'shift.id',
                        'shift.label',
                        'custom_1',
                        'custom_2',
                    ],
                    pagination: {
                        perPage: -1
                    }
                })
                .then(({data}) => {
                    resolve(data.data);
                });
        })
            .then((guestlists) => {
                this.guestlists = guestlists;
                this.stateParams.guestlists = this.guestlists;
                this.availableShifts = {};
                this.availableDates = {};
                this.guestlistMapping = [];
                _.each(this.guestlists, (guestlist) => {
                    const curGuestlistDate = new Date(guestlist.date),
                        cleanFormattedDate = this.filter('date')(curGuestlistDate, 'yyyy-MM-dd');

                    if (!this.availableShifts[cleanFormattedDate]) {
                        this.availableShifts[cleanFormattedDate] = {};
                    }

                    if (!this.availableShifts[cleanFormattedDate][guestlist.shift.id]) {
                        this.availableShifts[cleanFormattedDate][guestlist.shift.id] = guestlist.shift.label;
                    }

                    if (!this.availableDates[cleanFormattedDate]) {
                        this.availableDates[cleanFormattedDate] = this.filter('date')(curGuestlistDate, 'EEEE, dd.MM.yyyy');
                    }

                    this.guestlistMapping.push({
                        id: guestlist.id,
                        date: cleanFormattedDate,
                        shift: guestlist.shift.id
                    });
                });
            });
    }

    // Public functions

    activateGroup(group) {
        this.currentGroup = group.id;
        this._updateCustomActions();
        this._updateToolbox();
        this._resetSelected();
    }

    //
    // // Seatplan Events
    handleSeatplanClick(e, clickedElement) {
        if (this.bookingInformation[clickedElement.id]) {
            this.handleBookingInformationOpen(this.bookingInformation[clickedElement.id]);
        } else {

        }
    }

    handleSeatplanDblClick(e, clickedElement) {
        if (this.bookingInformation[clickedElement.id]) {
            this.handleBookingInformationOpen(this.bookingInformation[clickedElement.id]);
        } else {
            if (this.selected.ids.indexOf(clickedElement.id) === -1) {
                this.handleSeatplanSelectionChange(clickedElement, true);
            }
            this.openBookingModal();
        }
    }

    handleBookingInformationOpen(bookingInformation) {
        if(bookingInformation.length > 1) {
            this.showMultiBookingsSelectionModal(bookingInformation);
        } else {
            this.openRsvpInformationModal(bookingInformation[0].rsvp);
        }
    }

    showMultiBookingsSelectionModal(bookingInformation) {
        this.modal
            .open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: multipleElementsSelectModalTemplate,
                size: 'md',
                controller: MultipleElementsSelectModalController,
                controllerAs: 'vm',
                resolve: {
                    guestlist: () => {
                        return this.guestlist;
                    },
                    bookingInformation: () => {
                        return bookingInformation;
                    }
                }
            })
            .result
            .then((bookingInformation) => {
                this.openRsvpInformationModal(bookingInformation.rsvp)
            }, () => {

            });
    }

    handleSeatplanUnSelectable(clickedElement) {
        console.log('seatplan un selectable', clickedElement);
    }

    handleSeatplanSelectionChange(triggeredElement, selectionState, allSelectedElements) {
        this._updateToolbox();

        this.scope.$apply(() => {
            const newSelection = {
                ids: [],
                objects: []
            };

            _.each(allSelectedElements, (element) => {
                newSelection.ids.push(element.id);
                newSelection.objects.push(element);
            });
            this.selected = newSelection;
            this._updateToolbox();
        });
    }

    updateGuestlistById(id) {
        this.state.go(this.state.current.name, {
            ...this.stateParams,
            rsvpId: undefined,
            guestlist: null,
            gid: id,
            preSelectGroup: this.currentGroup
        });
    }

    openBookingModal() {
        this.modal
            .open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: doBookingModalTemplate,
                size: 'xlg',
                controller: 'DoBookingModalController',
                controllerAs: 'vm',
                resolve: {
                    selectedObjects: () => {
                        return this.selected.objects;
                    },
                    seatplan: () => {
                        return this.seatplan;
                    },
                    guestlist: () => {
                        return this.guestlist;
                    },
                    bookingInformation: () => {
                        return this.bookingInformation;
                    },
                    currentGroup: () => {
                        return this.currentGroup;
                    },
                    blockedElements: () => {
                        return this.blockedElements;
                    }
                }
            })
            .result
            .then((success) => {
                this._refreshRsvpInformation();
                this._resetSelected();
            }, () => {
                this._refreshRsvpInformation();
            });
    }

    //

    openRsvpInformationModal(rsvp) {
        this.modal
            .open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: bookingInformationModalTemplate,
                size: 'xlg',
                backdrop: false,
                controller: 'BookingInformationModalController',
                controllerAs: 'vm',
                resolve: {
                    model: () => {
                        return this.api
                            .get(`rsvps/${rsvp.id}?include=contact,guestlist,guestlistCombination`)
                            .then(({data}) => data.data)
                            .catch(e => this.alert.handle(e));
                    },
                    seatplan: () => {
                        return this.seatplan;
                    },
                    guestlist: () => {
                        return this.guestlist;
                    },
                    bookingInformation: () => {
                        return this.bookingInformation;
                    },
                    currentGroup: () => {
                        return this.currentGroup;
                    },
                    blockedElements: () => {
                        return this.blockedElements;
                    },
                    reloadCallback: () => {
                        return () => {
                            return this._refreshRsvpInformation()
                                .then(() => {
                                    return this.bookingInformation
                                });
                        }
                    }
                }
            })
            .result
            .then(() => {
                this._refreshRsvpInformation();
            })
            .catch(() => {
                this._refreshRsvpInformation();
            });
    }

    //
    tryGuestlistUpdate() {
        this.guestlistSelectionError = false;
        let newGuestlistAry = this.filter('filter')(this.guestlistMapping, {
            date: this.currentSelectedDate,
            shift: this.currentSelectedShift
        });

        if (newGuestlistAry.length === 0) {
            this.guestlistSelectionError = true;
        } else {
            this.updateGuestlistById(newGuestlistAry[0].id);
        }
    }

    //
    // // Private functions
    _resetSelected() {
        this.resetSelectedIndex++;
        this.selected = {
            objects: [],
            ids: []
        };
        this._updateToolbox();
    }

    _refreshRsvpInformation() {
        this.selected = {
            ids: [],
            objects: []
        };

        return this.api
            .post(`fp/${this.guestlistId}/rsvps/seatplan-elements`, {
                fields: [
                    'id',
                    'custom_label',
                    'pax',
                    'element.id',
                    'element.title',
                    'element.pax',
                    'rsvp.id',
                    'rsvp.booking_number',
                    'rsvp.blocked',
                    'rsvp.status',
                    'rsvp.comment',
                    'rsvp.custom_label',
                    'rsvp.area_start_time',
                    'rsvp.area_end_time',
                    'rsvp.custom_start_time',
                    'rsvp.custom_end_time',
                    'rsvp.pax_planned',
                    'rsvp.seatplan_element_pax',
                    'rsvp.seatplan_element_count',
                    'rsvp.last_invoice_type',
                    'rsvp.last_invoice_status',
                    'rsvp.checked_in_sign',
                    'rsvp.direct_booking_sign',
                    'rsvp.invited_at',
                    'rsvp.migrate_to_new_year',
                    'rsvp.deleted_at',
                    'rsvp.already_shipped_sign',
                    'contact.id',
                    'contact.customer_number',
                    'contact.full_name',
                    'contact.company_name',
                    'contact.first_name',
                    'contact.last_name',
                    'contact.cnr_full_name_co'
                ],
                pagination: {
                    perPage: -1
                },
                filters: [
                    {
                        field: 'rsvp.deleted_at',
                        operator: '=',
                        value: null
                    }
                ]
            })
            .then(({data}) => {
                const newBookingInformation = {};

                _.each(data.data, (bookedElement) => {
                    if(!newBookingInformation[bookedElement.element.id]) {
                        newBookingInformation[bookedElement.element.id] = [];
                    }

                    newBookingInformation[bookedElement.element.id].push(bookedElement)
                });

                this.bookingInformation = newBookingInformation;
                angular.element(window).trigger('resize');
            })
    }

    _updateCustomActions() {
        this.navService.shouldShowBackBtn(false);
        const customs = [];
        _.each(this.seatplan.groups.data, (group) => {
            customs.push({
                label: group.title,
                key: 'group-' + group.id,
                icon: 'char-' + group.title[0].toLowerCase(),
                order: group.title[0].toLowerCase(),
                action: () => {
                    this.activateGroup(group);
                },
                active: group.id === this.currentGroup
            });
        });

        this.navService.setSideNavCustoms(customs);
    }

    _updateToolbox() {
        const actions = [];

        if (this.acl.hasRight('rsvps::create')) {
            actions.push({
                label: 'Create new booking',
                action: () => {
                    this.openBookingModal();
                },
                icon: 'plus-circle',
                order: 20
            });
        }

        this.navService.overrideMainSideNavActions(actions);
    }

    _initPusherWatcher() {
        this.usersFastPipe.state.pusher.bind('new-checkin', data => {
            if (data.guestlist_id === this.guestlistId) {
                this._refreshRsvpInformation();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/seatplan-controller.js